module.exports = __webpack_public_path__ + "static/OTDCover-cb9d443113afa5549ae0f9354cb2faae.jpg";